const BLOB_STORAGE = `${process.env.REACT_APP_AZURE_BLOB_STORAGE}`;

export const BLOB_STORAGE_LOGO = `${BLOB_STORAGE}/logos`;
export const BLOB_STORAGE_REMESSA = `${BLOB_STORAGE}/remessas`;
export const BLOB_STORAGE_LANCAMENTOS = `${BLOB_STORAGE}/anexoslancamentos`;
